import type { ComponentPropsWithoutRef } from 'react';

import clsx from 'clsx';

// Types
import type { IconProps } from '@/components/base/Icon';
// Components
import Icon from '@/components/base/Icon';
import type { TooltipProps } from '@/components/base/Tooltip';
import Tooltip from '@/components/base/Tooltip';

export type ButtonIconProps = ComponentPropsWithoutRef<'button'> &
    Pick<IconProps, 'icon'> & {
        isActive?: boolean;
        tooltip?: TooltipProps['content'];
        smaller?: boolean;
    };

const ButtonIcon = ({ icon, isActive, tooltip, smaller, ...restProps }: ButtonIconProps) => (
    <span
        className={clsx('relative inline-block', {
            'text-base': !smaller,
            'text-xs': smaller,
            'text-icoGray-500 dark:text-icoDarkMode-wolf': !isActive,
            'text-icoBlue': isActive
        })}>
        <Tooltip content={tooltip} placement="top">
            <button className="focus:ring-0 focus:ring-offset-0" {...restProps}>
                <Icon icon={icon} />
            </button>
        </Tooltip>
        {isActive && !smaller ? (
            <span className="absolute -bottom-2 left-0 h-0.5 w-full bg-icoBlue" />
        ) : null}
    </span>
);

export default ButtonIcon;
